import { StylesConfig } from 'react-select';
import styled, { DefaultTheme } from 'styled-components';

import { ButtonStyled } from '../../../../components/Button/Button.styled';
import Heading from '../../../../components/Heading/Heading.styled';
import { SelectOptionsT } from '../../../../components/SelectDropdown/SelectDropdown';

export const ButtonsWrapperStyled = styled.div`
  display: flex;
  gap: 15px;
  margin-top: 30px;

  ${({ theme }) => `
    ${ButtonStyled} {
      &:first-of-type {
        border-color: ${theme.borderColour};
      }

      flex: 1;
      padding: 5px 20px;
    }  

    ${theme.devices.mobile} {
      flex-direction: column;      
    }
  `}
`;

export const FieldLabelStyled = styled.label`
  display: inline-block;
`;

export const FormWrapperStyled = styled.div``;

export const FieldsRowStyled = styled.div`
  display: flex;
  gap: 10px;

  ${({ theme }) => `
    & + & {
      margin-top: 35px;

      ${theme.devices.mobile} {
        margin-top: 10px;
      }
    }

    ${theme.devices.mobile} {
      flex-direction: column;
    }
  `}
`;

export const FieldsColStyled = styled.div`
  flex: 1;
`;

export const SubTitleStyled = styled(Heading)`
  margin: 50px 0 40px;
`;

export function getSelectStyles(theme: DefaultTheme): StylesConfig<SelectOptionsT, boolean> {
  return {
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected || state.isFocused ? '#fff' : '#000',
      backgroundColor: state.isFocused || state.isSelected ? theme.primaryColour : '',
      padding: 10,

      '&:active': {
        backgroundColor: theme.primaryColour,
      },
    }),
  };
}
